import { takeLatest, put } from 'redux-saga/effects';

import { updateComponent } from 'modules/quotes/quoteItems/data/actions';

import { confirmModal, types } from './actions';

export default function* root() {
  yield takeLatest(
    types.CONFIRM_UPDATE_PROCESS_MATERIAL_REQUEST,
    watchConfirmProcessMaterialUpdate,
  );
}

function* watchConfirmProcessMaterialUpdate(action) {
  const { payload } = action;
  const {
    componentId,
    processId,
    materialId,
    supplierMaterialId,
    shouldKeepExistingOperations,
  } = payload;
  yield put(
    updateComponent.request({
      componentId: componentId,
      data: {
        processId,
        materialId,
        supplierMaterialId,
        shouldKeepExistingOperations,
      },
    }),
  );
  yield put(confirmModal.close);
}
